// extracted by mini-css-extract-plugin
export default {"link":"SelectLocale_link__ADdaG"};